import { useCallback } from 'react'
import req from '@sportninja/common/api/request'
import type { AudienceBreakdownData } from '../components/AudienceBreakdownSection'

interface UseAudienceCalculatorProps {
  selectedEntityId: string | undefined
  selectedEntityType: string | null
  activeCompetition: boolean
  onLoadingChange?: (isLoading: boolean) => void
  onDataChange?: (data: AudienceBreakdownData | null) => void
}

export const useAudienceCalculator = ({
  selectedEntityId,
  selectedEntityType,
  activeCompetition,
  onLoadingChange,
  onDataChange,
}: UseAudienceCalculatorProps) => {
  const calculateAudience = useCallback(async () => {
    if (!selectedEntityId || !selectedEntityType) {
      onLoadingChange?.(false)
      onDataChange?.(null)
      return
    }

    try {
      onLoadingChange?.(true)
      let type = ''
      if (selectedEntityType?.includes('org')) {
        type = 'organization'
      } else if (selectedEntityType?.includes('team')) {
        type = 'team'
      } else if (
        selectedEntityType?.includes('sched') ||
        selectedEntityType?.includes('competition')
      ) {
        type = 'competition'
      }

      const url = `/social-feed/${selectedEntityId}/${type}${
        activeCompetition ? '?active_competition=1' : '?active_competition=0'
      }`
      const { data } = await req(url)
      onDataChange?.(data)
    } catch (error) {
      console.error('Failed to fetch audience data:', error)
      onDataChange?.(null)
    } finally {
      onLoadingChange?.(false)
    }
  }, [
    selectedEntityId,
    selectedEntityType,
    activeCompetition,
    onLoadingChange,
    onDataChange,
  ])

  return { calculateAudience }
}
